import React from "react";

import "./Loader.scss";

export enum LoaderPosition {
  Global = "global",
  Local = "local",
}

export const Loader = ({ position = LoaderPosition.Global }) => (
  <div className={`loader loader-${position}`}>
    <div className="loader__dot loader__dot--1" />
    <div className="loader__dot loader__dot--2" />
    <div className="loader__dot loader__dot--3" />
  </div>
);
